export const version = '2.19.1';
//# sourceMappingURL=version.js.map